import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../About.css';

const Finance = () => {
  const solutions = ['Banking Platforms', 'Payment Processing', 'Trading Systems', 'Risk Management', 'Compliance & Reporting', 'Fraud Detection'];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Financial Services Solutions</h1>
          <p>Secure, compliant software for banking, fintech, and financial institutions</p>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Building Trust Through Technology</h2>
            <p>
              We develop secure financial software that meets stringent regulatory requirements including
              PCI-DSS, SOX, and regional banking regulations. Our solutions handle millions of transactions
              with enterprise-grade security and reliability.
            </p>
          </div>
        </div>
      </section>

      <section className="about-expertise">
        <div className="container">
          <div className="section-header"><h2>Financial Solutions</h2></div>
          <div className="expertise-grid">
            {solutions.map((s, i) => <div key={i} className="expertise-item">{s}</div>)}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Secure Your Financial Operations</h2>
            <p>Contact us to discuss your financial software needs.</p>
            <Link to="/contact">
              <Button variant="contained" size="large" endIcon={<ArrowForwardIcon />}
                sx={{ backgroundColor: '#2271b1', color: '#ffffff', fontWeight: '600', padding: '14px 32px', fontSize: '15px', textTransform: 'none', borderRadius: '3px', boxShadow: '0 1px 0 #135e96', '&:hover': { backgroundColor: '#135e96' } }}>
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Finance;
